import IErrorEndpoint from 'src/types/IErrorEndpoint';

function isErrorResponse(data: any): data is IErrorEndpoint {
  return (data as IErrorEndpoint).error !== undefined;
}

export default isErrorResponse;
